module.exports = __webpack_public_path__ + "static/img/banner_product5.ac191c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comm/banner_product5.jpg
// module id = jhts
// module chunks = 0